function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
/*********************************************************************************

 WEB3 CRYPTO MODULE v.2 - Mixin

 Extends the generic web3 crypto module to add auto-support for cryptos that are
 supported by the Mixin module.

 returnPrivateKey()
 async sendPayment(amount="", recipient="", unique_hash="")
 async receivePayment(amount="", sender="", recipient="", timestamp=0, unique_hash="")


 Uses Mixin API:
 ----------------
 createAccount()
 createDepositAddress()
 fetchSafeUtxoBalance()
 fetchUtxo()
 fetchSafeSnapshots()
 fetchSnapshots()
 fetchPendingDeposits()
 sendInNetworkTransferRequest()
 sendExternalNetworkTransferRequest()
 returnMixinNetworkInfo()
 returnWithdrawalFee()
 deposit[]
 mixin.privatekey
 mixin.user_id


 **********************************************************************************/
var CryptoModule = require('./../../../lib/templates/cryptomodule');
var getUuid = require('uuid-by-string');
//
// TODO - this is old and deprecated and doesn't compile well with ().default bundled
// code as we require. so we should be updating address validation if we need it, but
// this should not be blocking us.
//
var WAValidator = require('@taasfi/multicoin-address-validator');
var MixinModule = /*#__PURE__*/function (_CryptoModule) {
  function MixinModule(app, mixin_mod, ticker, asset_id, chain_id) {
    var _this;
    _classCallCheck(this, MixinModule);
    _this = _callSuper(this, MixinModule, [app, ticker]);
    _this.mixin = mixin_mod;
    _this.asset_id = asset_id;
    _this.chain_id = chain_id;
    _this.polling_active = 0;
    _this.polling_timeout = 0;
    _this.polling_intervals = [5000, 15000, 45000, 90000, 120000, 180000];
    _this.polling_interval_current = 0;
    _this.cached_contacts = [];
    _this.confirmations = 100;
    return _this;
  }
  _inherits(MixinModule, _CryptoModule);
  return _createClass(MixinModule, [{
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result, rv, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              if (this.mixin.account_created) {
                _context.n = 2;
                break;
              }
              console.info('Create Mixin account');
              _context.n = 1;
              return this.mixin.createAccount();
            case 1:
              result = _context.v;
              if (!(result !== null && result !== void 0 && result.err || !this.mixin.account_created)) {
                _context.n = 2;
                break;
              }
              throw new Error((result === null || result === void 0 ? void 0 : result.err) || 'Mixin account was not created');
            case 2:
              if (this.address) {
                _context.n = 5;
                break;
              }
              console.info("Create Mixin deposit address -- ".concat(this.ticker));
              _context.n = 3;
              return this.mixin.createDepositAddress(this.asset_id, this.chain_id);
            case 3:
              rv = _context.v;
              if (rv) {
                _context.n = 4;
                break;
              }
              throw new Error('Mixin deposit address was not created');
            case 4:
              console.info("Address for ".concat(this.ticker, ": ").concat(this.address));
            case 5:
              _context.n = 6;
              return _superPropGet(MixinModule, "activate", this, 3)([]);
            case 6:
              return _context.a(2, true);
            case 7:
              _context.p = 7;
              _t = _context.v;
              console.error("Unable to activate ".concat(this.ticker, ":"), _t);
              if (this.app.BROWSER) {
                salert("Having problem generating key for ".concat(this.ticker));
              }
              _context.n = 8;
              return this.app.wallet.setPreferredCrypto('SAITO');
            case 8:
              return _context.a(2, false);
          }
        }, _callee, this, [[0, 7]]);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
  }, {
    key: "loadHistory",
    value: function () {
      var _loadHistory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(MixinModule, "loadHistory", this, 3)([]);
            case 1:
              _context2.n = 2;
              return this.checkForRecentTransactions();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function loadHistory() {
        return _loadHistory.apply(this, arguments);
      }
      return loadHistory;
    }() //
    // Balance state (see also getPendingBalance, sendPayment, checkForRecentTransactions):
    //
    // - balance: confirmed Safe UTXO from fetchSafeUtxoBalance; persisted via save()
    // - pending_balance: ephemeral post-send expected balance until the API reflects the
    //   transfer; also drives returnDisplayBalance() and header "pending" styling
    // - last_balance: ephemeral pre-send snapshot for a synthetic pending row in the
    //   recent transactions overlay until the snapshot lands in history
    //
    // pending_balance and last_balance are not persisted in save().
    //
  }, {
    key: "fetchBalance",
    value: function () {
      var _fetchBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var ts, balance;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (this.address) {
                _context3.n = 1;
                break;
              }
              console.info('Mixin Error: no address - terminating fetch balance');
              return _context3.a(2);
            case 1:
              ts = Date.now(); //
              // We are adding some throttling here because this was getting called > 10 times
              // just on page load. The polling / checkForRecentTransactions will clear the flag
              // if there is any activity that would update things
              //
              if (!(!this.last_balance_fetch || ts - this.last_balance_fetch > 10000)) {
                _context3.n = 3;
                break;
              }
              console.log('@@@ FetchBalance ' + this.ticker);
              this.last_balance_fetch = ts;
              _context3.n = 2;
              return this.mixin.fetchSafeUtxoBalance(this.asset_id);
            case 2:
              balance = _context3.v;
              if (balance !== false) {
                // API caught up to the post-send estimate; drop the optimistic override.
                if (balance == this.pending_balance) {
                  delete this.pending_balance;
                }
                if (this.balance != balance) {
                  this.balance = balance;
                  this.save();
                }
              }
            case 3:
              return _context3.a(2, this.balance);
          }
        }, _callee3, this);
      }));
      function fetchBalance() {
        return _fetchBalance.apply(this, arguments);
      }
      return fetchBalance;
    }()
  }, {
    key: "getAvailableBalance",
    value: function () {
      var _getAvailableBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              return _context4.a(2, this.fetchBalance());
          }
        }, _callee4, this);
      }));
      function getAvailableBalance() {
        return _getAvailableBalance.apply(this, arguments);
      }
      return getAvailableBalance;
    }() //
    // queries the latest pending balance
    //
  }, {
    key: "getPendingBalance",
    value: function () {
      var _getPendingBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var pending_balance, _iterator, _step, pd, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _t2 = Number;
              _context5.n = 1;
              return this.getAvailableBalance();
            case 1:
              pending_balance = _t2(_context5.v);
              // Did we cache a pending balance because we just sent some tokens and cannot trust the safeUTXOBalance?
              if (this.pending_balance) {
                if (pending_balance !== this.pending_balance) {
                  pending_balance = this.pending_balance;
                }
              }

              // Do we have incoming deposits from outside the platform?
              _context5.n = 2;
              return this.fetchPendingDeposits();
            case 2:
              this.pending_deposits = _context5.v;
              _iterator = _createForOfIteratorHelper(this.pending_deposits);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  pd = _step.value;
                  if (pd.state === 'pending' || Number(pd.confirmations) < Number(this.confirmations)) {
                    pending_balance += Number(pd.amount || 0);
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              return _context5.a(2, pending_balance.toString() || '0');
          }
        }, _callee5, this);
      }));
      function getPendingBalance() {
        return _getPendingBalance.apply(this, arguments);
      }
      return getPendingBalance;
    }()
    /*
     *
     * PENDING DEPOSITS are returned from MIXIN in this fashion
     *
     * this.pending_deposits = [
     *   {
     *     deposit_id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
     *     destination: "0xDepositAddressForThisAsset...",
     *     tag: "",
     *     chain_id: "b7938390-ff6d-4be9-aa99-1a7ede2b7276",
     *     asset_id: "c6d0c728-2624-429b-8e0d-d563e5f5ee48",
     *     asset_key: "ETH",
     *     amount: "0.125",              // string; use Number() in UI
     *     transaction_hash: "0xabc...",
     *     output_index: 0,
     *     block_hash: "0xdef...",
     *     block_number: 19876543,
     *     confirmations: 5,             // used by saito-header / deposit overlay
     *     threshold: 100,             // network confirmation target (often matches module.confirmations)
     *     state: "pending",             // e.g. "pending" | "confirmed"
     *     created_at: "2024-02-12T16:31:44.123456789Z",
     *     updated_at: "2024-02-12T16:32:01.987654321Z"
     *   }
     * ];
     */
  }, {
    key: "fetchPendingDeposits",
    value: function () {
      var _fetchPendingDeposits = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this2 = this;
        var callback,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              callback = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : null;
              if (this.address) {
                _context6.n = 1;
                break;
              }
              this.pending_deposits = [];
              if (callback) callback([]);
              return _context6.a(2, []);
            case 1:
              _context6.n = 2;
              return new Promise(function (resolve) {
                _this2.mixin.fetchPendingDeposits(_this2.asset_id, _this2.address, function (res) {
                  if (res === false) {
                    resolve(_this2.pending_deposits || []);
                    return;
                  }
                  resolve(res || []);
                });
              });
            case 2:
              this.pending_deposits = _context6.v;
              if (callback) {
                callback(this.pending_deposits);
              }
              return _context6.a(2, this.pending_deposits);
          }
        }, _callee6, this);
      }));
      function fetchPendingDeposits() {
        return _fetchPendingDeposits.apply(this, arguments);
      }
      return fetchPendingDeposits;
    }()
  }, {
    key: "getSaitoPublicKey",
    value: function getSaitoPublicKey(user_id) {
      //
      // check if address exists in local db
      //
      for (var pk in this.cached_contacts) {
        if (this.cached_contacts[pk].includes(user_id)) {
          return pk;
        }
      }
      var _iterator2 = _createForOfIteratorHelper(this.app.keychain.returnKeys()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _k$crypto_addresses;
          var k = _step2.value;
          if (k !== null && k !== void 0 && (_k$crypto_addresses = k.crypto_addresses) !== null && _k$crypto_addresses !== void 0 && (_k$crypto_addresses = _k$crypto_addresses[this.ticker]) !== null && _k$crypto_addresses !== void 0 && _k$crypto_addresses.includes(user_id)) {
            return k.publicKey;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return false;
    }
  }, {
    key: "validateHistory",
    value: function () {
      var _validateHistory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var i, _t3;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _superPropGet(MixinModule, "validateHistory", this, 3)([]);
            case 1:
              i = 0;
            case 2:
              if (!(i < this.history.length)) {
                _context7.n = 6;
                break;
              }
              if (!(this.history[i].counter_party.address && !this.history[i].counter_party.publicKey)) {
                _context7.n = 5;
                break;
              }
              if (!(this.history[i].counter_party.publicKey !== '')) {
                _context7.n = 5;
                break;
              }
              _t3 = this.getSaitoPublicKey(this.history[i].counter_party.address);
              if (_t3) {
                _context7.n = 4;
                break;
              }
              _context7.n = 3;
              return this.remoteUserFetch(this.history[i].counter_party.address);
            case 3:
              _t3 = _context7.v;
            case 4:
              this.history[i].counter_party.publicKey = _t3;
            case 5:
              i++;
              _context7.n = 2;
              break;
            case 6:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function validateHistory() {
        return _validateHistory.apply(this, arguments);
      }
      return validateHistory;
    }()
  }, {
    key: "remoteUserFetch",
    value: function () {
      var _remoteUserFetch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(user_id) {
        var _this3 = this,
          _user;
        var user;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              user = null; // It is very strange that we seem to be unable to pass values back from
              // this asynchronous function, though I swear there are places in the code where
              // we expect that behavior.
              // This setting a variable through the callback, with an await (to make sure the callback gets called)
              // seems to do the trick
              _context8.n = 1;
              return this.mixin.sendFetchUserTransaction({
                asset_id: this.asset_id,
                user_id: user_id
              }, function (res) {
                if ((res === null || res === void 0 ? void 0 : res.length) > 0) {
                  var _res$;
                  // Cache this results!
                  var address = res[0].address;
                  if ((_res$ = res[0]) !== null && _res$ !== void 0 && _res$.user_id) {
                    address += '|' + res[0].user_id + '|mixin';
                  }
                  if (res[0].publickey) {
                    var pk = res[0].publickey;
                    _this3.cached_contacts[pk] = address;
                    // save address to keychain if publickey exists in keychain
                    if (_this3.app.keychain.hasPublicKey(pk)) {
                      _this3.app.keychain.addCryptoAddress(pk, _this3.ticker, address);
                    }
                  }
                  user = res[0];
                }
              });
            case 1:
              return _context8.a(2, ((_user = user) === null || _user === void 0 ? void 0 : _user.publickey) || '');
          }
        }, _callee8, this);
      }));
      function remoteUserFetch(_x) {
        return _remoteUserFetch.apply(this, arguments);
      }
      return remoteUserFetch;
    }()
    /**
     * Mixin represents an internal account in two equivalent ways:
     *
     *   chain-address|mixin-user-uuid|mixin
     *   mixin-user-uuid
     *
     * Expected payments are commonly registered with the first form while Safe
     * snapshots report the second. Match on the Mixin user UUID when one side is
     * packed, while CryptoModule keeps exact sender matching for other networks.
     */
  }, {
    key: "returnPaymentSenderIdentity",
    value: function returnPaymentSenderIdentity() {
      var sender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var address = String(sender || '').trim();
      var parts = address.split('|');
      if (parts.length >= 3 && parts[parts.length - 1].toLowerCase() === 'mixin') {
        return parts[parts.length - 2].toLowerCase();
      }
      return address.toLowerCase();
    }
  }, {
    key: "paymentsHaveSameSender",
    value: function paymentsHaveSameSender(expected_sender, actual_sender) {
      if (_superPropGet(MixinModule, "paymentsHaveSameSender", this, 3)([expected_sender, actual_sender])) {
        return true;
      }
      var expected_identity = this.returnPaymentSenderIdentity(expected_sender);
      var actual_identity = this.returnPaymentSenderIdentity(actual_sender);
      return Boolean(expected_identity && actual_identity && expected_identity === actual_identity);
    }

    /**
     * Look up one inbound Safe transfer using the transaction signature supplied
     * in its Saito announcement. This lets callers recover an expected payment
     * after an in-memory polling cursor has already passed the snapshot.
     */
  }, {
    key: "findInboundPaymentBySignature",
    value: function () {
      var _findInboundPaymentBySignature = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _this4 = this;
        var transaction_signature,
          amount,
          sender,
          created_at,
          timestamp,
          lookup_start,
          snapshots,
          snapshot,
          _args9 = arguments;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              transaction_signature = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : '';
              amount = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : '';
              sender = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : '';
              created_at = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : 0;
              if (!(!transaction_signature || !this.asset_id)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2, null);
            case 1:
              timestamp = Number(created_at) || 0;
              lookup_start = timestamp > 0 ? Math.max(timestamp - 300000, 0) : 0;
              _context9.n = 2;
              return this.mixin.fetchSafeSnapshots(this.asset_id, lookup_start);
            case 2:
              snapshots = _context9.v;
              if (Array.isArray(snapshots)) {
                _context9.n = 3;
                break;
              }
              return _context9.a(2, null);
            case 3:
              snapshot = snapshots.find(function (candidate) {
                return Number(candidate === null || candidate === void 0 ? void 0 : candidate.amount) > 0 && (candidate === null || candidate === void 0 ? void 0 : candidate.transaction_hash) === transaction_signature && (!(candidate !== null && candidate !== void 0 && candidate.asset_id) || candidate.asset_id === _this4.asset_id) && Number(candidate.amount) === Number(amount) && _this4.paymentsHaveSameSender(sender, (candidate === null || candidate === void 0 ? void 0 : candidate.opponent_id) || '');
              });
              if (snapshot) {
                _context9.n = 4;
                break;
              }
              return _context9.a(2, null);
            case 4:
              return _context9.a(2, {
                ticker: this.ticker,
                amount: String(snapshot.amount),
                receiver: this.publicKey,
                receiver_address: this.formatAddress() || '',
                sender_address: snapshot.opponent_id || '',
                timestamp: new Date(snapshot.created_at).getTime(),
                transaction_signature: snapshot.transaction_hash,
                memo: snapshot.memo || ''
              });
          }
        }, _callee9, this);
      }));
      function findInboundPaymentBySignature() {
        return _findInboundPaymentBySignature.apply(this, arguments);
      }
      return findInboundPaymentBySignature;
    }()
    /**
     * Incremental history / snapshot sync: fetch new Safe ledger events, append to history,
     * emit semantic payment events, and advance history_update_ts.
     */
  }, {
    key: "checkForRecentTransactions",
    value: function () {
      var _checkForRecentTransactions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var _this5 = this;
        var fetched_updates, snapshots, _iterator3, _step3, snap, obj, pk, _t4;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              if (this.isActivated()) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2, []);
            case 1:
              console.log('@@@ checkForRecentTransactions -- ' + this.ticker);
              fetched_updates = [];
              if (this.asset_id) {
                _context0.n = 2;
                break;
              }
              return _context0.a(2, []);
            case 2:
              _context0.n = 3;
              return new Promise(function (resolve) {
                _this5.mixin.fetchSafeSnapshots(_this5.asset_id, _this5.history_update_ts + 1, function (d) {
                  resolve(d === false || d == null ? [] : d);
                });
              });
            case 3:
              snapshots = _context0.v;
              if (snapshots.length > 0) {
                // Real ledger activity arrived; allow fetchBalance and drop the synthetic
                // pending history row (details overlay uses last_balance until this point).
                delete this.last_balance_fetch;
                delete this.last_balance;
              }
              _iterator3 = _createForOfIteratorHelper(snapshots);
              _context0.p = 4;
              _iterator3.s();
            case 5:
              if ((_step3 = _iterator3.n()).done) {
                _context0.n = 12;
                break;
              }
              snap = _step3.value;
              //
              // Snapshot object returned by Mixin Safe API (via mixin.js fetchSafeSnapshots):
              //
              // {
              //   snapshot_id: "6049b6c2-3f9e-3627-b671-c81f4f6a88fa",
              //   user_id: "95b8a0a4-1032-33e7-9154-5f48ebe00a14",
              //   opponent_id: "dac46e33-fdd2-3453-b77a-73ffadba1ff1",
              //   transaction_hash: "1db6dc53df33bfc7dd38afa86eb83454b5b71bc178da653431ddc9af025a7487",
              //   asset_id: "43d61dcd-e413-450d-80b8-101d5e903357",
              //   kernel_asset_id: "8dd50817c082cdcdd6f167514928767a4b52426997bd6d4930eca101c5ff8a27",
              //   amount: "0.005",
              //   memo: "746573742d6d656d6f",
              //   request_id: "bfb05bb6-03e5-4b5c-a7ab-2ad5a4ed56a7",
              //   created_at: "2025-08-25T03:23:17.657426Z",
              //   level: 11,
              //   type: "snapshot",
              //   inscription_hash: "INSCRIPTION-HASH",
              //   deposit: {
              //     deposit_hash: "DEPOSIT-HASH",
              //     deposit_index: 1,
              //     sender: "SOME-STRING",
              //     destination: "DEPOSIT-DESTINATION",
              //     tag: "DEPOSIT-TAG"
              //   },
              //   withdrawal: {
              //     withdrawal_hash: "WITHDRAWAL-HASH",
              //     receiver: "SOME-STRING"
              //   }
              // }
              //
              obj = {
                snapshot_id: snap.snapshot_id,
                counter_party: {
                  address: ''
                },
                timestamp: new Date(snap.created_at).getTime(),
                amount: Number(snap.amount),
                trans_hash: snap.transaction_hash || ''
              };
              if (!(obj.timestamp < this.history_update_ts)) {
                _context0.n = 6;
                break;
              }
              return _context0.a(3, 11);
            case 6:
              if (snap.deposit) {
                //obj.type = 'deposit';
                obj.type = 'receive';
                obj.counter_party.address = snap.deposit.sender || '';
              } else if (snap.withdrawal) {
                //obj.type = 'withdraw';
                obj.type = 'send';
                obj.counter_party.address = snap.withdrawal.receiver || '';
              } else if (obj.amount > 0) {
                obj.type = 'receive';
              } else {
                obj.type = 'send';
              }
              if (!(snap !== null && snap !== void 0 && snap.opponent_id)) {
                _context0.n = 10;
                break;
              }
              pk = this.getSaitoPublicKey(snap.opponent_id);
              if (pk) {
                _context0.n = 8;
                break;
              }
              _context0.n = 7;
              return this.remoteUserFetch(snap.opponent_id);
            case 7:
              pk = _context0.v;
            case 8:
              if (pk) {
                obj.counter_party.publicKey = pk;
              }
              _context0.n = 9;
              return this.processAddress(snap.opponent_id, false);
            case 9:
              obj.counter_party.address = _context0.v;
            case 10:
              this.history.push(obj);
              fetched_updates.push(obj);
              if (obj.type === 'deposit' || obj.type === 'receive') {
                this.app.connection.emit('on-payment-received', {
                  ticker: this.ticker || '',
                  amount: String(Math.abs(obj.amount)),
                  receiver: this.publicKey,
                  receiver_address: this.formatAddress() || '',
                  sender_address: (obj === null || obj === void 0 ? void 0 : obj.counter_party.address) || 'unknown',
                  sender: (obj === null || obj === void 0 ? void 0 : obj.counter_party.publicKey) || 'unknown',
                  timestamp: obj.timestamp,
                  transaction_signature: obj.trans_hash
                  //memo: snap.memo || ''
                });
              } else if (obj.type === 'send' || obj.type === 'withdraw') {
                this.app.connection.emit('on-payment-sent', {
                  ticker: this.ticker || '',
                  amount: String(Math.abs(obj.amount)),
                  receiver_address: (obj === null || obj === void 0 ? void 0 : obj.counter_party.address) || 'unknown',
                  receiver: (obj === null || obj === void 0 ? void 0 : obj.counter_party.publicKey) || 'unknown',
                  sender_address: this.formatAddress() || '',
                  sender: this.publicKey,
                  timestamp: obj.timestamp,
                  transaction_signature: obj.trans_hash
                  //memo: snap.memo || ''
                });
              }
              this.history_update_ts = Math.max(this.history_update_ts, obj.timestamp);
            case 11:
              _context0.n = 5;
              break;
            case 12:
              _context0.n = 14;
              break;
            case 13:
              _context0.p = 13;
              _t4 = _context0.v;
              _iterator3.e(_t4);
            case 14:
              _context0.p = 14;
              _iterator3.f();
              return _context0.f(14);
            case 15:
              if (snapshots.length > 0) {
                this.save();
              }
              return _context0.a(2, fetched_updates);
          }
        }, _callee0, this, [[4, 13, 14, 15]]);
      }));
      function checkForRecentTransactions() {
        return _checkForRecentTransactions.apply(this, arguments);
      }
      return checkForRecentTransactions;
    }()
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      this.polling_active = 0;
      if (this.polling_timeout) {
        clearTimeout(this.polling_timeout);
        this.polling_timeout = null;
      }
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      var _this6 = this;
      //
      // if we are already polling, increase urgency by reducing interval index
      //
      if (this.polling_active) {
        if (this.polling_interval_current > 0) {
          this.polling_interval_current--;
        }
        return;
      }

      //
      // record that we are polling
      //
      this.polling_active = 1;
      this.polling_interval_current = 0;
      var _poll = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
          var wallet_updates, still_waiting, delay;
          return _regenerator().w(function (_context1) {
            while (1) switch (_context1.n) {
              case 0:
                if (_this6.polling_active) {
                  _context1.n = 1;
                  break;
                }
                return _context1.a(2);
              case 1:
                _context1.n = 2;
                return _this6.checkForRecentTransactions();
              case 2:
                wallet_updates = _context1.v;
                // We could also independently hit the API for pendingDeposits...
                //
                // if something has happened....
                // or nothing is going to happen...
                //
                still_waiting = Object.keys(_this6.transfers_inbound).length > 0;
                if (!((wallet_updates === null || wallet_updates === void 0 ? void 0 : wallet_updates.length) > 0 && !still_waiting || _this6.polling_interval_current >= _this6.polling_intervals.length)) {
                  _context1.n = 3;
                  break;
                }
                _this6.stopPolling();
                return _context1.a(2);
              case 3:
                //
                // schedule next poll
                //
                delay = _this6.polling_intervals[_this6.polling_interval_current];
                _this6.polling_interval_current++;
                _this6.polling_timeout = setTimeout(_poll, delay);
              case 4:
                return _context1.a(2);
            }
          }, _callee1);
        }));
        return function poll() {
          return _ref.apply(this, arguments);
        };
      }();

      //
      // now start!
      //
      _poll();
      return;
    }

    /**
     * Abstract method which should transfer tokens via the crypto endpoint
     * @abstract
     * @param {Number} howMuch - How much of the token to transfer
     * @param {String} to - Pubkey/address to send to
     * @abstract
     * @return {Number}
     */
  }, {
    key: "sendPayment",
    value: function () {
      var _sendPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var _res;
        var amount,
          recipient,
          unique_hash,
          memo,
          internal_transfer,
          destination,
          r,
          res,
          _res$message,
          _res2,
          _args10 = arguments;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              amount = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : '';
              recipient = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : '';
              unique_hash = _args10.length > 2 && _args10[2] !== undefined ? _args10[2] : '';
              memo = _args10.length > 3 && _args10[3] !== undefined ? _args10[3] : '';
              internal_transfer = false;
              _context10.n = 1;
              return this.processAddress(recipient);
            case 1:
              destination = _context10.v;
              r = destination.split('|');
              res = {};
              console.info('Mixin sendPayment to ' + destination);

              //
              // if address has |mixin| concat --> internal mixin transfer
              //
              if (!(r.length >= 2)) {
                _context10.n = 4;
                break;
              }
              if (!(r[2] === 'mixin')) {
                _context10.n = 3;
                break;
              }
              _context10.n = 2;
              return this.mixin.sendInNetworkTransferRequest(this.asset_id, r[1], amount, memo);
            case 2:
              res = _context10.v;
            case 3:
              _context10.n = 7;
              break;
            case 4:
              if (!this.validateAddress(destination)) {
                _context10.n = 6;
                break;
              }
              _context10.n = 5;
              return this.mixin.sendExternalNetworkTransferRequest(this.asset_id, destination, amount, memo);
            case 5:
              res = _context10.v;
              _context10.n = 7;
              break;
            case 6:
              throw new Error("MixinModule: invalid address for ".concat(this.ticker, " -- "), destination);
            case 7:
              if (!(((_res = res) === null || _res === void 0 ? void 0 : _res.status) == 200)) {
                _context10.n = 9;
                break;
              }
              // Safe UTXO balance lags after send; cache expected post-send balance and
              // pre-send snapshot until fetchBalance / checkForRecentTransactions confirm.
              if (Number.isFinite(res.pending_balance)) {
                this.pending_balance = res.pending_balance;
              }
              if (!this.last_balance) {
                this.last_balance = this.balance;
              }
              if (!((_res$message = res.message) !== null && _res$message !== void 0 && _res$message.length)) {
                _context10.n = 8;
                break;
              }
              return _context10.a(2, res.message[0].transaction_hash || unique_hash);
            case 8:
              return _context10.a(2, unique_hash);
            case 9:
              throw new Error('MixinModule: ' + (((_res2 = res) === null || _res2 === void 0 ? void 0 : _res2.message) || 'payment failed'));
            case 10:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function sendPayment() {
        return _sendPayment.apply(this, arguments);
      }
      return sendPayment;
    }() //
    // Reference for how we used to package the mixin address bar...
    //
  }, {
    key: "formatAddress",
    value: function formatAddress() {
      return this.address + '|' + this.mixin.mixin.user_id + '|' + 'mixin';
    }

    /**
     * Abstract method which should get private key
     * @abstract
     * @return {String} Private Key
     */
  }, {
    key: "returnPrivateKey",
    value: function returnPrivateKey() {
      return this.mixin.mixin.privatekey;
    }
  }, {
    key: "returnMixinNetworkInfo",
    value: function () {
      var _returnMixinNetworkInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var info;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _context11.n = 1;
              return this.mixin.returnMixinNetworkInfo(this.asset_id);
            case 1:
              info = _context11.v;
              this.confirmations = info.confirmations || 0;
              this.price_usd = Number(info.price_usd);
              this.last_update = Date.now();
              this.icon_url = info.icon_url;
              return _context11.a(2, info);
          }
        }, _callee11, this);
      }));
      function returnMixinNetworkInfo() {
        return _returnMixinNetworkInfo.apply(this, arguments);
      }
      return returnMixinNetworkInfo;
    }() //
    // this function creates a Mixin address associated with the account in order to check
    // if it can offer zero-fee in-network transfers or requires a network fee to be paid
    // in order to process the payment.
    //
  }, {
    key: "checkWithdrawalFeeForAddress",
    value: function () {
      var _checkWithdrawalFeeForAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var address,
          mycallback,
          r,
          ts,
          fee,
          _this$mixin$crypto_mo,
          feeBalance,
          feeModule,
          _args12 = arguments;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              address = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : '';
              mycallback = _args12.length > 1 ? _args12[1] : undefined;
              if (!(address == '')) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2, mycallback(0));
            case 1:
              _context12.n = 2;
              return this.processAddress(address);
            case 2:
              address = _context12.v;
              r = address.split('|');
              ts = new Date().getTime(); //
              // internal MIXIN transfer, 0 fee
              //
              if (!(r.length >= 2)) {
                _context12.n = 4;
                break;
              }
              if (!(r[2] === 'mixin')) {
                _context12.n = 3;
                break;
              }
              return _context12.a(2, mycallback(0));
            case 3:
              _context12.n = 8;
              break;
            case 4:
              _context12.n = 5;
              return this.mixin.returnWithdrawalFee(this.asset_id, address);
            case 5:
              fee = _context12.v;
              if (!(fee !== false)) {
                _context12.n = 7;
                break;
              }
              _context12.n = 6;
              return this.mixin.fetchSafeUtxoBalance(fee.asset_id);
            case 6:
              feeBalance = _context12.v;
              feeModule = (_this$mixin$crypto_mo = this.mixin.crypto_mods) === null || _this$mixin$crypto_mo === void 0 ? void 0 : _this$mixin$crypto_mo.find(function (crypto_module) {
                return crypto_module.asset_id === fee.asset_id;
              });
              return _context12.a(2, mycallback(fee.amount, _objectSpread(_objectSpread({}, fee), {}, {
                ticker: (feeModule === null || feeModule === void 0 ? void 0 : feeModule.ticker) || fee.ticker,
                available_balance: feeBalance === false ? null : feeBalance
              })));
            case 7:
              return _context12.a(2, mycallback(0));
            case 8:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function checkWithdrawalFeeForAddress() {
        return _checkWithdrawalFeeForAddress.apply(this, arguments);
      }
      return checkWithdrawalFeeForAddress;
    }()
    /**
     * Abstract method which returns snapshot of asset withdrawls, deposits
     * @abstract
     * @return {Function} Callback function
     */
  }, {
    key: "fetchHistory",
    value: function () {
      var _fetchHistory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var ts,
          mycallback,
          newTransactions,
          _args13 = arguments;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              ts = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : null;
              mycallback = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : null;
              _context13.n = 1;
              return this.checkForRecentTransactions();
            case 1:
              newTransactions = _context13.v;
              if (mycallback != null) {
                mycallback(this.history);
              }
            case 2:
              return _context13.a(2);
          }
        }, _callee13, this);
      }));
      function fetchHistory() {
        return _fetchHistory.apply(this, arguments);
      }
      return fetchHistory;
    }()
  }, {
    key: "returnUtxo",
    value: function () {
      var _returnUtxo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var state,
          limit,
          order,
          callback,
          _args14 = arguments;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              state = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : 'unspent';
              limit = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : 500;
              order = _args14.length > 2 && _args14[2] !== undefined ? _args14[2] : 'DESC';
              callback = _args14.length > 3 && _args14[3] !== undefined ? _args14[3] : null;
              _context14.n = 1;
              return this.mixin.fetchUtxo(state, limit, order, callback);
            case 1:
              return _context14.a(2, _context14.v);
          }
        }, _callee14, this);
      }));
      function returnUtxo() {
        return _returnUtxo.apply(this, arguments);
      }
      return returnUtxo;
    }()
  }, {
    key: "returnAddressFromPublicKey",
    value: function () {
      var _returnAddressFromPublicKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(publicKey) {
        var key, address, _t5;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.p = _context15.n) {
            case 0:
              this_self = this;
              _context15.p = 1;
              if (!this.cached_contacts[publicKey]) {
                _context15.n = 2;
                break;
              }
              return _context15.a(2, this.cached_contacts[publicKey]);
            case 2:
              key = this.app.keychain.returnKey(publicKey, true);
              if (!(key !== null && key !== void 0 && key.crypto_addresses)) {
                _context15.n = 3;
                break;
              }
              return _context15.a(2, key.crypto_addresses[this.ticker]);
            case 3:
              // if it doesnt exist fetch it from node db
              address = '';
              _context15.n = 4;
              return this.mixin.sendFetchUserTransaction({
                publicKey: publicKey,
                asset_id: this.asset_id
              }, function (res) {
                if (res.length > 0) {
                  for (var i = 0; i < res.length; i++) {
                    if (res[i].asset_id == this_self.asset_id) {
                      var _res$i;
                      address = res[i].address;
                      if ((_res$i = res[i]) !== null && _res$i !== void 0 && _res$i.user_id) {
                        address += '|' + res[i].user_id + '|mixin';
                      }
                      this_self.cached_contacts[publicKey] = address;
                      // save address to keychain if publickey exists in keychain
                      if (this_self.app.keychain.hasPublicKey(publicKey)) {
                        this_self.app.keychain.addCryptoAddress(publicKey, this_self.ticker, address);
                      }
                      return address;
                    }
                  }
                }
              });
            case 4:
              return _context15.a(2, address);
            case 5:
              _context15.p = 5;
              _t5 = _context15.v;
              return _context15.a(2, null);
          }
        }, _callee15, this, [[1, 5]]);
      }));
      function returnAddressFromPublicKey(_x2) {
        return _returnAddressFromPublicKey.apply(this, arguments);
      }
      return returnAddressFromPublicKey;
    }()
    /**
     * Mixin specific function to minimize the amount of table look ups
     * @destination (string) the chain address for the token -- no validation (?)
     * @remote_fallback (boolean) -- we are overloading this function to also function as a
     * 								search through our cache and keychain to get the full formatted address from
     * 								the mixin_id...
     */
  }, {
    key: "processAddress",
    value: function () {
      var _processAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(destination) {
        var _this7 = this;
        var remote_fallback,
          pk,
          _iterator4,
          _step4,
          _k$crypto_addresses2,
          k,
          _args16 = arguments,
          _t6,
          _t7,
          _t8;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.p = _context16.n) {
            case 0:
              remote_fallback = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : true;
              if (!destination.includes('|mixin')) {
                _context16.n = 1;
                break;
              }
              return _context16.a(2, destination);
            case 1:
              if (!this.app.crypto.isPublicKey(destination)) {
                _context16.n = 3;
                break;
              }
              _context16.n = 2;
              return this.returnAddressFromPublicKey(destination);
            case 2:
              return _context16.a(2, _context16.v);
            case 3:
              _t6 = _regeneratorKeys(this.cached_contacts);
            case 4:
              if ((_t7 = _t6()).done) {
                _context16.n = 6;
                break;
              }
              pk = _t7.value;
              if (!this.cached_contacts[pk].includes(destination)) {
                _context16.n = 5;
                break;
              }
              return _context16.a(2, this.cached_contacts[pk]);
            case 5:
              _context16.n = 4;
              break;
            case 6:
              _iterator4 = _createForOfIteratorHelper(this.app.keychain.returnKeys());
              _context16.p = 7;
              _iterator4.s();
            case 8:
              if ((_step4 = _iterator4.n()).done) {
                _context16.n = 10;
                break;
              }
              k = _step4.value;
              if (!(k !== null && k !== void 0 && (_k$crypto_addresses2 = k.crypto_addresses) !== null && _k$crypto_addresses2 !== void 0 && (_k$crypto_addresses2 = _k$crypto_addresses2[this.ticker]) !== null && _k$crypto_addresses2 !== void 0 && _k$crypto_addresses2.includes(destination))) {
                _context16.n = 9;
                break;
              }
              return _context16.a(2, k.crypto_addresses[this.ticker]);
            case 9:
              _context16.n = 8;
              break;
            case 10:
              _context16.n = 12;
              break;
            case 11:
              _context16.p = 11;
              _t8 = _context16.v;
              _iterator4.e(_t8);
            case 12:
              _context16.p = 12;
              _iterator4.f();
              return _context16.f(12);
            case 13:
              if (!remote_fallback) {
                _context16.n = 14;
                break;
              }
              _context16.n = 14;
              return this.mixin.sendFetchUserTransaction({
                address: destination,
                asset_id: this.asset_id
              }, function (res) {
                if (res !== null && res !== void 0 && res.length) {
                  var user_data = res[0];
                  if (user_data !== null && user_data !== void 0 && user_data.publickey && user_data.user_id) {
                    destination += '|' + user_data.user_id + '|mixin';
                    // Cache return values
                    _this7.cached_contacts[user_data.publickey] = destination;
                    if (_this7.app.keychain.hasPublicKey(user_data.publickey)) {
                      _this7.app.keychain.addCryptoAddress(user_data.publickey, _this7.ticker, destination);
                    }
                  }
                }
              });
            case 14:
              return _context16.a(2, destination);
            case 15:
              return _context16.a(2);
          }
        }, _callee16, this, [[7, 11, 12, 13]]);
      }));
      function processAddress(_x3) {
        return _processAddress.apply(this, arguments);
      }
      return processAddress;
    }()
  }, {
    key: "validateAddress",
    value: function validateAddress(address) {
      var _this8 = this;
      if (address.includes('|')) {
        var r = address.split('|');
        address = r[0];
      }
      try {
        var _this$mixin;
        var chain = (_this$mixin = this.mixin) === null || _this$mixin === void 0 || (_this$mixin = _this$mixin.crypto_mods) === null || _this$mixin === void 0 ? void 0 : _this$mixin.find(function (crypto_module) {
          return crypto_module.asset_id === _this8.chain_id;
        });
        return WAValidator.validate(address, (chain === null || chain === void 0 ? void 0 : chain.ticker) || this.ticker);
      } catch (err) {
        console.error("Error 'validateAddress' MixinModule: ", err);
        return false;
      }
    }
  }]);
}(CryptoModule);
module.exports = MixinModule;